/**
 * 万里汇（WorldFirst）合作落地页 —— 服务端数据获取
 *
 * 需求来源：docs/万里汇合作落地页/万里汇合作落地页-提示词.md 第1次提交 需求5（任务单 DEV-124229）。
 *
 * 纯展示页面，不调用任何后端 API，仅返回 SEO 信息与 CDN 配置。
 *
 * 【注意】cdnHost 获取链路（与 odm/alternatives/cjBusinessTravel 一致）：
 * - SSR 模式：eggCtx.app.config.view.variable.CDN_HOST
 * - CSR fallback：layout 模板注入的全局变量 CDN_HOST
 *   本地开发下该值指向**测试环境 OSS 桶**（config/config.default.js:9,86 写死 ossHost["test"]），
 *   不是空串——图片须先发布到测试环境才看得到，详见 images.js 头注释第 3 条。
 *
 * 【注意】__seo 三段文案由需求文档第 5 条逐字给定，投放素材与搜索结果标题按它对齐，
 *        改动前须与业务方确认；单测 CASE-S1 对三段做逐字全等断言。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @returns {Object} 包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx) {
  let cdnHost = '';
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost,
    __seo: {
      title: 'CJdropshipping & WorldFirst | Global Payments + $100 Bonus',
      keywords:
        'CJdropshipping WorldFirst, WorldFirst, WorldFirst account, global payments',
      description:
        'Join WorldFirst through CJdropshipping to collect and send global payments, ' +
        'manage multiple currencies, pay suppliers, and unlock an exclusive US$100 bonus.',
    },
  };
}

module.exports = fetchData;
